import type { ReactNode } from "react";
import { ProgressBar } from "@/components/ProgressBar";

interface WizardShellProps {
  stepIndex: number;
  totalSteps: number;
  progress: number;
  imageSrc?: string;
  imageAlt?: string;
  children: ReactNode;
}

export function WizardShell({
  stepIndex,
  totalSteps,
  progress,
  imageSrc,
  imageAlt,
  children,
}: WizardShellProps) {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col px-5 pb-12 pt-6">
      <div className="max-w-xl">
        <ProgressBar value={progress} current={stepIndex + 1} total={totalSteps} />
      </div>
      <div className={`mt-8 grid flex-1 gap-10 ${imageSrc ? "lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]" : ""}`}>
        <div>{children}</div>
        {imageSrc ? (
          <div className="hidden lg:block">
            <img
              src={imageSrc}
              alt={imageAlt ?? ""}
              width={640}
              height={800}
              className="h-auto w-full max-w-md"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
